import { VStack } from '../VStack';
import { DriveFolderUpload } from '../asset';
import { DEFAULT_EMPTY_LIST_TEXT } from './constant';

const VFileBrowserEmptyTree = ({ message }: { message?: string }) => {
  return (
    <VStack className="py-10 text-gray-300" items="center" gap={0.25}>
      <DriveFolderUpload className="h-12 w-12" />

      <div>
        {(message ?? DEFAULT_EMPTY_LIST_TEXT.TREE).replaceAll('\\n', '\n')}
      </div>
    </VStack>
  );
};

export default VFileBrowserEmptyTree;
